import { z } from 'zod';

export const PaymentCardCreateSchema = z.object({
    team_id: z.string().uuid().nullable(),
});
